export default "__VITE_ASSET__XHQ3aQ9Q__"